// extracted by mini-css-extract-plugin
export var attribution = "_bq-4";
export var authorName = "_bq-5";
export var quote = "_bq-3";
export var testimonial = "_bq-2";
export var trustedBy = "_bq-0";
export var trustedByLabel = "_bq-1";